import { Tab as HeadlessTab } from "@headlessui/react";

type Props = Readonly<{
  children: React.ReactNode;
}>;

export function Tab({ children }: Props): JSX.Element {
  return <HeadlessTab className={styles}>{children}</HeadlessTab>;
}

export function styles({ selected }: { selected: boolean }) {
  return `focus:ring-0 focus:outline-none inline-block rounded-full py-2 px-4 border border-transparent text-black dark:text-white text-sm mr-2 ${
    selected ? "border-primary bg-white dark:bg-gray-900" : ""
  }`;
}
